<div class="io-graph">
  @if (loading) {
    <p>Loading I/O graph…</p>
  }
  @if (chartData?.length) {
    <flexible-chart
      [data]="chartData"
      typeOfChart="bar"
      [isRange]="false"
      [options]="{ axisX: true, axisY: true }"
    ></flexible-chart>
  }
</div>
